import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n' // Inicializar i18n antes de la app
import './styles/globals.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
